import { React, useState } from 'react'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import { PropTypes } from 'prop-types'
import Subscribe from '../../assets/joinus.jpg'
import LoginPopup from '../Login/LoginPopup'
import RegisterWatcher from '../Watcher/RegisterWatcher'
import UIButton from '../../components/UI/UIButton'
import INT from '../../config/index'
import { useNavigate } from 'react-router-dom'

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '450px',
    '@media (max-width: 480px)': {
      width: '100vw',
      height: '230px',
      flexDirection: 'column',
    },
  },
  backgroundImage: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: '-1',
  },
  title: {
    position: 'absolute',
    width: '100%',
    height: '100px',
    margin: 'auto',
    marginTop: '210px',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: 110,
    letterSpacing: '-0.035em',
    lineHeight: '110px',
    textAlign: 'center',
    alignItems: 'center',
    color: 'white',
    fontFamily: 'Helvetica Neue LT W05_75 Bd Ou',
    '@media (max-width: 1024px)': {
      fontSize: 70,
    },
    '@media (max-width: 480px)': {
      margin: '0',
      position: 'relative',
      paddingTop: '15px',
      height: '50px',
      fontSize: 40,
    },
  },
  proTitle: {
    position: 'absolute',
    width: '100%',
    height: '100px',
    margin: 'auto',
    marginTop: '120px',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: 110,
    letterSpacing: '-0.035em',
    lineHeight: '110px',
    textAlign: 'center',
    alignItems: 'center',
    color: 'white',
    '@media (max-width: 1024px)': {
      fontSize: 70,
    },
    '@media (max-width: 480px)': {
      margin: '0',
      paddingTop: '30px',
      position: 'relative',
      height: '50px',
      fontSize: 40,
    },
  },
  button: {
    position: 'absolute',
    borderRadius: '50px',
    justifyContent: 'center',
    backgroundColor: '#61C4CE',
    color: 'white',
    padding: '1.5em 3em',
    margin: '2em auto',
    fontWeight: 700,
    letterSpacing: '-0.05em',
    bottom: '0',
    left: '50%',
    transform: 'translateX(-50%)',
    '@media (max-width: 480px)': {
      width: '200px',
      height: '40px',
    },
  },
  text: {
    fontWeight: 700,
    letterSpacing: '-0.05em',
    fontSize: '18px',
    whiteSpace: 'nowrap',
    // textAlign: 'center',
  },
})
function ProSub({ buttonId }) {
  const { t } = useTranslation('Pro')

  let navigate = useNavigate()

  const [isLoginOpened, setLoginOpened] = useState(false)
  const [isRegisterOpened, setRegisterOpened] = useState(false)

  const handleLogin = () => {
    setLoginOpened(true)
  }

  const handleLoginClose = () => {
    setLoginOpened(false)
  }

  const handleRegisterClose = () => {
    setRegisterOpened(false)
  }

  const handleCreateAccount = () => {
    setLoginOpened(false)
    setRegisterOpened(true)
  }

  const handleSubmitRegister = () => {
    setLoginOpened(true)
    setRegisterOpened(false)
  }

  const onLoginSuccess = () => {
    navigate('/create-request')
  }

  return (
    <>
      <div
        className={css(styles.container)}
        // onClick={() => {
        //   if (INT.AUTH_PERM) {
        //     handleLogin()
        //   }
        // }}
      >
        <img
          src={Subscribe}
          className={css(styles.backgroundImage)}
          alt="women with phone"
          width="100%"
          height="100%"
        />
        <p className={css(styles.proTitle)}>{t('register')}</p>
        <p className={css(styles.title)}>{t('now')}</p>
        <UIButton
          id={buttonId}
          label={t('Isub')}
          dynamicStyle={styles.button}
          textStyle={styles.text}
          disabled={!INT.AUTH_PERM}
          onClick={() => {
            if (INT.AUTH_PERM) {
              handleLogin()
            }
          }}
          noSpan
        />
      </div>
      <LoginPopup
        isOpened={isLoginOpened}
        onClose={handleLoginClose}
        onCreateAccount={handleCreateAccount}
        onLoginSuccess={onLoginSuccess}
      />
      <RegisterWatcher
        isOpened={isRegisterOpened}
        onClose={handleRegisterClose}
        onReturn={() => {
          setLoginOpened(true)
          handleRegisterClose()
        }}
        onSubscription={handleSubmitRegister}
      />
    </>
  )
}

ProSub.propTypes = {
  buttonId: PropTypes.string,
}

export default ProSub
